// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fn-logout-icon[data-v-7971e864]{width:.5314rem;height:.5314rem;margin-right:.24155rem;opacity:.8}", ""]);
// Exports
module.exports = exports;
